import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ModalService} from './services/modal.service';
import { SharedModule } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';

declare const $: any;

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: true,
    imports: [DialogModule, SharedModule]
})
export class ModalComponent implements OnInit, OnDestroy {
  @Input() id: string;

  @Output() tearDown = new EventEmitter<any>();
  
  public visible = false;
  public visibleAnimate = false;
  
  @Input()
  contentStyleInput: any;

  @Input() style: string;

  @Input() dismissableMask = false;

  constructor(private modalService: ModalService) { }

  public show(): void {
    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 300);
  }

  public EmitHide() {
    document.body.style.overflowY = 'auto';
    this.tearDown.emit();
  }

  public backgroundClick(event) {
    const target = event.currentTarget.id;
    const targetTgt = event.target.id;
    if (targetTgt && targetTgt === 'modal-background') {
      this.hide();
    }
  }
  public hide(): void {
    this.visible = false;

    setTimeout(() => this.visible = false, 300);
  }
  ngOnInit(): void {
    const modal = this;

    // ensure required id attribute exists, error if not set
    if (!this.id) {
      //console.error('app-modal component must have an id');
      return;
    }
    this.modalService.add(this);
  }

  ngOnDestroy(): void {
    this.modalService.remove(this.id);
  }

}

/***
 * Modal component usage:
 *
 * ModalService should be a provider at app.module.
 *
 * Parent module must declare ModalComponent as import.
 *
 * Define @Input id when declaring app-modal. This is required.
 *
 * ModalService should be imported and declared in constructor of parent component.
 *
 * Parent component should implement modalService.open(idString)/.close(idString)
 * to control modal. This can occur in the html click binding or code.
 *
 * Use declarations for .app-modal-header, .app-modal-body, .app-modal-footer to define ng-content in those areas.
 *
 *
 *  Example app-modal:
 * <button type="button" (click)="modalService.open('testModal1')">Open Test Modal 1</button>
 * <app-modal id="testModal1">
 * <span class="app-modal-header">
 * header
 * </span>
 * <div class="app-modal-body">
 * body
 * </div>
 * <span class="app-modal-footer">
 * <button type="button" class="btn btn-default" (click)="modalService.close('testModal1')">Close</button>
 * </span>
 * </app-modal>
 *
 */
